import { render, staticRenderFns } from "./BBAlert.vue?vue&type=template&id=58489d73&scoped=true&"
import script from "./BBAlert.vue?vue&type=script&lang=js&"
export * from "./BBAlert.vue?vue&type=script&lang=js&"
import style0 from "./BBAlert.vue?vue&type=style&index=0&id=58489d73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58489d73",
  null
  
)

export default component.exports